module.exports = __webpack_public_path__ + "asset/image-Paw-581428c046b6c5c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/Paw.svg
// module id = ZieB
// module chunks = 0